/* jshint esversion: 6 */
import React from 'react';
import Sidebar from 'app/components/common/SideBar.jsx';
import Content from 'app/components/common/Content.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as _ from "underscore";
import { Link } from 'react-router-dom';
import { Breakpoint } from 'react-socks';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import MinimalModal from 'app/components/Modals/MinimalModal.jsx';
import FeatureCallout from 'app/components/common/FeatureCallout.jsx';
import WelcomeModal from '@/shadcn/components/NewAutomation/WelcomeModal.tsx';
import Draggable from 'react-draggable';


class Welcome extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            version: 'Shad2026'
        }
        this.onTileClick = this.onTileClick.bind(this);
        this.draggableRef = React.createRef();

    }

    componentDidMount() {
        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

        if (this.props.recordEvent && onboarding) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Welcome Modal - View',
                event_data: {
                    version: this.state.version
                }
            });
        }
    }

    onTileClick(option) {
        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

        if (this.props.recordEvent && onboarding) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Welcome Modal - Tile Click',
                event_data: {
                    tile: option.title
                }
            });
        }
        this.props.router.navigate(option.link);
    }

    render() {
        let welcomeContent = null,
            imgPath = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            optionButtons = [
                {
                    title: 'Automate Posts',
                    icon: 'icon ion-ios-bolt',
                    desc: 'Auto post from RSS, Instagram, Facebook & more.',
                    link: '/share/automate/new/inputs'
                },
                {
                    title: 'Compose Post',
                    icon: 'icon ion-edit',
                    desc: 'Create and schedule a new post.',
                    link: '/content/post'
                },
            ],
        cancelAction = (source) => {
            let cancelSource = 'Close button',
                onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

            if (typeof source === "string") {
                cancelSource = source;
            }
            if (this.props.recordEvent && onboarding) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Welcome Modal - Close',
                    event_data: {
                        source: cancelSource
                    }
                });
            }
            this.props.router.navigate('/share/automate/new/inputs');
        };


        return (
            <div>
                <Breakpoint desktop only>
                    <Sidebar navItems={[
                        {
                            iconClass: 'icon ion-plus sidebar-icon',
                            label: 'New Automation',
                            labelClass: 'sidebar-label',
                            link: '/share/automate/new/inputs',
                            isHeader: false,
                            manualActive: false
                        },
                        {
                            iconClass: 'icon ion-ios-bolt-outline sidebar-icon',
                            label: 'Import/Discover',
                            labelClass: 'sidebar-label',
                            link: '/content/import',
                            isHeader: false
                        },
                        {
                            iconClass: 'icon ion-log-in sidebar-icon',
                            label: 'WP Connections',
                            labelClass: 'sidebar-label',
                            link: '/content/connections',
                            isHeader: false
                        },
                        {
                            iconClass: 'icon ion-ios-upload-outline sidebar-icon',
                            label: 'Import CSV',
                            labelClass: 'sidebar-label',
                            link: '/content/csv',
                            isHeader: false
                        }
                    ]} />
                </Breakpoint>
                <div className="dlvr-modal">
                    <Breakpoint desktop only>
                        <Draggable nodeRef={this.draggableRef} handle=".pt-accessory-modal" cancel=".pt-accessory-close, .action-cancel, .action-delete, .pt-scheduler, .gallery-search, .image-editor-display, .pt-accessory-content, .image-list, .tw-root">
                            <div ref={this.draggableRef} className={"pt-accessory-modal welcome"} role="dialog" aria-modal="true">
                                <div className="tw-root">
                                    <WelcomeModal
                                        cancelHandler={cancelAction}
                                        clickHandler={this.onTileClick}/>
                                </div>
                            </div>
                        </Draggable>
                    </Breakpoint>
                    {/*
                     * react-draggable 4.4.3 preventDefaults touchstart as soon as the handle
                     * matches, which swallows the click that would have followed. The handle here
                     * is the whole modal, so on touch no button inside it ever fires. Dragging is
                     * pointless on a phone anyway, so mobile renders the surface undraggable.
                     */}
                    <Breakpoint mobile only>
                        <div className={"pt-accessory-modal welcome"} role="dialog" aria-modal="true">
                            <div className="tw-root">
                                <WelcomeModal
                                    cancelHandler={cancelAction}
                                    clickHandler={this.onTileClick}/>
                            </div>
                        </div>
                    </Breakpoint>
                </div>
                <Content/>
            </div>
        );

    }
}

Welcome.displayName = "Welcome";

export default ComponentWithContext(Welcome);
